import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { array, TArrayCodec } from "../../../shared/src/codecs/types/array";
import { dateTime } from "../../../shared/src/codecs/types/dateTime";
import { form, TFormCodec } from "../../../shared/src/codecs/types/form";
import { longString } from "../../../shared/src/codecs/types/longString";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string } from "../../../shared/src/codecs/types/string";
import { union } from "../../../shared/src/codecs/types/union";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";
import { TUuidObjectCodec, UuidObject } from "../Id";
import { CaseComplianceRaiseType } from "../CaseComplianceRaise";

export const CaseComplianceRaiseRevokeForm: TFormCodec<TUuidObjectCodec, TEmptyObjectCodec> = form(
    UuidObject,
    EmptyObject,
);
export type TCaseComplianceRaiseRevokeFormCodec = typeof CaseComplianceRaiseRevokeForm;
export type TCaseComplianceRaiseRevokeForm = TTypeOfCodec<TCaseComplianceRaiseRevokeFormCodec>;

export const CaseComplianceRaiseNewFormEditable = required({
    case_id: uuid(),
    note: union([longString(), nullCodec()]),
});
export type TCaseComplianceRaiseNewFormEditableCodec = typeof CaseComplianceRaiseNewFormEditable;

export const CaseComplianceRaiseNewForm: TFormCodec<typeof CaseComplianceRaiseNewFormEditable, TEmptyObjectCodec> = form(
    CaseComplianceRaiseNewFormEditable,
    EmptyObject,
);
export type TCaseComplianceRaiseNewFormCodec = typeof CaseComplianceRaiseNewForm;
export type TCaseComplianceRaiseNewForm = TTypeOfCodec<TCaseComplianceRaiseNewFormCodec>;

export const CaseComplianceRaiseFormEditable = required({
    note: union([longString(), nullCodec()]),
});
export type TCaseComplianceRaiseFormEditableCodec = typeof CaseComplianceRaiseFormEditable;

export const CaseComplianceRaiseFormReadOnly = required({
    id: uuid(),
    case_id: uuid(),
    type: CaseComplianceRaiseType,
    raised_at: dateTime(),
    raised_by_name: string(),
    revoke_form: CaseComplianceRaiseRevokeForm,
});
export type TCaseComplianceRaiseFormReadOnlyCodec = typeof CaseComplianceRaiseFormReadOnly;

export const CaseComplianceRaiseForm: TFormCodec<TCaseComplianceRaiseFormEditableCodec, TCaseComplianceRaiseFormReadOnlyCodec> = form(
    CaseComplianceRaiseFormEditable,
    CaseComplianceRaiseFormReadOnly,
);
export type TCaseComplianceRaiseFormCodec = typeof CaseComplianceRaiseForm;
export type TCaseComplianceRaiseForm = TTypeOfCodec<TCaseComplianceRaiseFormCodec>;

export const CaseComplianceRaisesForm: TFormCodec<
    TUuidObjectCodec,
    TRequiredCodec<{
        raises: TArrayCodec<TCaseComplianceRaiseFormCodec>,
        create_sar: TCaseComplianceRaiseNewFormCodec,
        create_insurers: TCaseComplianceRaiseNewFormCodec,
    }>
> = form(
    UuidObject,
    required({
        raises: array(CaseComplianceRaiseForm),
        create_sar: CaseComplianceRaiseNewForm,
        create_insurers: CaseComplianceRaiseNewForm,
    }),
);
export type TCaseComplianceRaisesFormCodec = typeof CaseComplianceRaisesForm;
export type TCaseComplianceRaisesForm = TTypeOfCodec<TCaseComplianceRaisesFormCodec>;
